<!-- <div class="content-container"> -->
<div class="container">
  <h1 class="font-lg mb-0">My invoices</h1>
  <div class="row mt-3">
    <div class="col-12">
      <table class="table table-responsive w-100 d-block d-md-table">
        <thead>
          <tr>
            <th>Invoice #</th>
            <th>Date</th>
            <th>Auction</th>
            <th class="text-right">Amount</th>
            <th class="text-right">Paid</th>
            <th class="text-right">Balance</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngIf="!pagedResponse">
            <tr>
              <td class="text-center" colspan="6">
                <strong><i class="fa fa-spinner fa-spin"></i> Retrieving invoices...</strong>
              </td>
            </tr>
          </ng-container>
          <ng-container *ngIf="pagedResponse">
            <tr *ngIf="!pagedResponse.InvoiceSummaryItems.length">
              <td class="text-center" colspan="6">
                <strong>No invoices to list</strong>
              </td>
            </tr>
            <tr *ngFor="let item of pagedResponse.InvoiceSummaryItems">
              <td><a [routerLink]="['detail',item.Invoice.Id]">{{item.Invoice.InvoiceNumber}}</a></td>
              <td>{{item.Invoice.DateCreated|date:'dd/MM/yyyy'}}</td>
              <td>{{item.Invoice.Auction.Title}}</td>
              <td class="text-right">{{GetTotals(item,"invoice")}}</td>
              <td class="text-right">{{GetTotals(item,"payments")}}</td>
              <td class="text-right">{{GetTotals(item,"balance")}}</td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div>
<!-- </div> -->
